import GATSBY_COMPILED_MDX from "C:/Users/krzys/code/MarysiaKlosinska/website/marklo/src/reference/10/index.mdx";
import * as React from "react";
import Layout from "../../components/layout";
import Seo from "../../components/seo";
import Video, {EmbededVideoType} from "../../components/videoPlayer";
import {GatsbyImage, getImage} from "gatsby-plugin-image";
import ReferenceDescription from "../../components/referenceDescription";
import Header from "../../components/header";
const BlogPost = _ref => {
  let {data, children} = _ref;
  const {frontmatter, excerpt} = data.mdx;
  const {videoSrcURL, title, videoType, referenceImages, description} = frontmatter;
  const images = referenceImages ? referenceImages.map(image => getImage(image)) : null;
  const renderVideo = videoSrcURL && videoType !== EmbededVideoType.EXTERNAL;
  return React.createElement(React.Fragment, null, React.createElement(Header, null), React.createElement(Layout, null, renderVideo && React.createElement(React.Fragment, null, React.createElement(Video, {
    videoSrcURL: videoSrcURL,
    videoTitle: title,
    videoType: videoType
  }), React.createElement(ReferenceDescription, {
    description: description,
    title: title
  })), videoType === EmbededVideoType.EXTERNAL ? React.createElement(React.Fragment, null, React.createElement(ReferenceDescription, {
    description: description,
    title: title
  }), React.createElement("h3", null, React.createElement("a", {
    target: "_blank",
    rel: "noopener noreferrer",
    href: videoSrcURL
  }, "Go to video")), images !== null && images.map((image, index) => React.createElement(GatsbyImage, {
    className: "referenceImage",
    key: index,
    image: image,
    alt: "Image " + (index + 1)
  }))) : !renderVideo && React.createElement("div", {
    className: "photoReferences"
  }, React.createElement(ReferenceDescription, {
    description: description,
    title: title
  }), images !== null && images.map((image, index) => React.createElement(GatsbyImage, {
    className: "referenceImage",
    key: index,
    image: image,
    alt: "Image " + (index + 1)
  })))));
};
const query = "1496587047";
export const Head = _ref2 => {
  let {data} = _ref2;
  return React.createElement(Seo, {
    title: data.mdx.frontmatter.title
  });
};
BlogPost
export default function GatsbyMDXWrapper(props) {
  return React.createElement(BlogPost, props, React.createElement(GATSBY_COMPILED_MDX, props));
}
